import { MAPS, score, type GameState } from '@cc/shared';

export function RegionLegend({ state }: { state: GameState }) {
  const map = MAPS[state.mapId];
  const breakdown = score(state);
  return <div className="region-legend" aria-label="Region control">{map.regions.map((region) => {
    const line = breakdown.regions.find((item) => item.regionId === region.id)!;
    return <div className={`region-chip ${line.bonusTo !== null ? `region-chip--${line.bonusTo === 0 ? 'gold' : 'silver'}` : ''}`} key={region.id}><span style={{ background: region.fill, borderColor: region.stroke }} />{region.name}<strong>{line.controlledSpaces[0]}–{line.controlledSpaces[1]}</strong></div>;
  })}</div>;
}
